(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("classnames"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["classnames", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["rcm-mobile"] = factory(require("classnames"), require("react"), require("react-dom"));
	else
		root["rcm-mobile"] = factory(root["classnames"], root["React"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_classnames__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
return 